export enum KrTypes {
  Qualitative,
  AccumulateQuantitative,
  UnAccumulateQuantitative,
}
